import { CopyToClipboard } from 'react-copy-to-clipboard';
import type { VoidFunctionComponent } from 'react';

import { useCopyToClipboard } from '../../../hooks/useCopyToClipboard';
import Button from '../Button/Button';

import './CopyPreformattedToClipboard.less';
import { icons, IconText } from '../Icon';

type Props = {
  text: string;
};

/**
 * Renders a block of inline pre-formatted text (ie: code sample)
 * with a small "copy to clipboard" button below it.
 *
 * @param {string} text - The preformatted text text.
 */
const CopyPreformattedToClipboard: VoidFunctionComponent<Props> = ({ text }) => {
  //  Handle setting the text of the "copy" button.
  const [isCopied, setIsCopied] = useCopyToClipboard();

  return (
    <div className="fossa-copy-preformatted">
      <pre className="fossa-copy-preformatted__pre">
        {text}
      </pre>
      <CopyToClipboard text={text}>
        <Button
          size="micro"
          type="outline"
          onClick={() => setIsCopied(true)}
        >
          <IconText
            icon={icons.clipboard}
            text={isCopied ? 'Copied to clipboard' : 'Copy to clipboard'}
          />
        </Button>
      </CopyToClipboard>
    </div>
  );
};

export default CopyPreformattedToClipboard;
